import { NgModule } from '@angular/core';

import { BadgeComponent } from './badge.component';
export { BadgeComponent };

@NgModule({
  imports: [BadgeComponent],
  exports: [BadgeComponent],
})
export class GalaxyBadgeModule {}
